<div [formGroup]="parentForm" class="position-relative">
    <input class="form__input" type="text"  placeholder="{{placeholder}}" formControlName="{{id}}" class="form__input" #addresstext>
    <mat-icon (click)="onClear()" *ngIf="addresstext.value.length > 0" class="input-icon" svgIcon="clearInputIcon" matSuffix></mat-icon>
    <mat-icon *ngIf="showError()" class="input-icon input-icon--error" svgIcon="inputErrorIcon" matSuffix></mat-icon>
    <span class="error-box" *ngIf="showError()">This field is required</span>
</div>

